export default "__VITE_ASSET__DziWep6$__"